<template>
  <n-config-provider :locale="zhCN" :dateLocale="dateZhCN" :themeOverrides="themeOverrides">
    <n-dialog-provider>
      <router-view v-if="showPage" class="min-h-100vh bg-#f3f3f3" :style="{ minWidth: `${$base.pageWidth + 48}px` }"></router-view>

      <div v-show="showSpin" class="spin-wp flex-center">
        <n-spin size="large"></n-spin>
      </div>

      <component :is="'style'">
        html, body { min-width: {{ $base.pageWidth + 48 }}px; }
      </component>
    </n-dialog-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import type { GlobalThemeOverrides } from 'naive-ui'
import { zhCN, dateZhCN, createDiscreteApi } from 'naive-ui'
import { composite } from 'seemly'

window.$route = useRoute()

nextTick(() => {
  window.$message = createDiscreteApi(['message']).message
})

const themeColor = '#003296'
const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: themeColor,
    primaryColorHover: composite(themeColor, [255, 255, 255, 0.2]),
    primaryColorPressed: composite(themeColor, [0, 0, 0, 0.12]),
    lineHeight: '22px',
  },
  Button: {
    borderRadiusMedium: '4px',
  },
  Input: {
    // color: 'rgba(0, 0, 0, 0.08)',
    // colorFocus: 'rgba(0, 0, 0, 0.08)',
    borderRadius: '4px',
    // border: '',
    borderHover: '',
    borderDisabled: '',
    borderFocus: '',
    boxShadowFocus: `0 0 0 2px ${themeColor}`,
  },
  DataTable: {
    lineHeight: '24px',
    thPaddingMedium: '8px 12px',
    tdPaddingMedium: '8px 12px',
    tdTextColor: '#606266',
    tdColorStriped: '#f9f9f9',
    tdColorHover: '#ecf2fe',
  },
}

const showPage = ref(true)
window.$reload = async () => {
  showPage.value = false
  await $util.sleep(0)
  showPage.value = true
}

const showSpin = ref(false)
window.$spin = {
  show: () => (showSpin.value = true),
  hide: () => (showSpin.value = false),
}
</script>

<style scoped lang="less">
.spin-wp {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999999999;
}
</style>
